<template>
    <div class="animated fadeIn h-100">
    <CCard v-if="view=='asset'" class="mb-0">
      <CCardBody>
        <CRow>
            <CCol sm="2" style="color: #39f; text-align:center; font-size: 22px; line-height:35px"><b>{{this.device}}</b></CCol>
            <CCol sm="2"><span class="float-left pr-2 pt-1">From: </span><date-picker ref="dateFrom" v-model="dateFrom" :config="options" style="width: initial;"></date-picker></CCol>
            <CCol sm="2"><span class="float-left pr-2 pt-1">To: </span><date-picker v-model="dateTo" :config="options" style="width: initial;"></date-picker></CCol>
            <CCol sm="2"><CButton color="info" shape="square" class="pl-5 pr-5" @click="updateMap()">Filter</CButton></CCol>
            <CCol sm="2"></CCol>
            <CCol sm="2" class="pt-2"><CSwitch class="mx-1" color="info" @change.native="updateMap()" checked variant="opposite" shape="pill" size="sm" v-bind:checked.sync="hideLowAcc"/> <span class="align-top">Hide low accuracy locations</span></CCol>
        </CRow>
        <CRow>
          <CCol sm="12">
            Timeline:
            <vue-slider v-model="currentMarker" v-bind="sliderOptions" :tooltip-formatter="timestampFormater"/>
          </CCol>
        </CRow>
      </CCardBody>
    </CCard>
    <gmap-map :center="center" :zoom="zoom" ref="mapa" map-type-id="roadmap" style="width: 100%; height: 100%">
      <gmap-cluster :grid-size="gridSize" v-if="clustering" v-on:click="clustering=false">
          <gmap-custom-marker v-if="view=='asset' || view=='world'" :key="index" v-for="(m, index) in markers" :marker="m.position" :clickable="true" @click.native="openDevice(m)" :title="m.devicename" style="margin-top: 16px;"><div class="mapMarker"><i :class="markerClass(m.event)" /></div></gmap-custom-marker>
      </gmap-cluster>

      <gmap-custom-marker v-if="(view=='asset' || view=='world') && clustering==false" :key="index" v-for="(m, index) in markers" :marker="m.position" :clickable="true" @click.native="openDevice(m)" :title="m.devicename" style="margin-top: 16px;"><div class="mapMarker"><i :class="markerClass(m.event)" /></div></gmap-custom-marker>
      <gmap-polyline v-if="view=='asset' && paths.length > 0" v-bind:path.sync="paths" v-bind:options="{ strokeColor:'#00800050'}" v-on:click="InfoWindowShown = true">
        <info-window :opened="InfoWindowShown" @closeclick="InfoWindowShown = false" >
        <h1>Test</h1>
        </info-window>
      </gmap-polyline>
    </gmap-map>
  </div>
</template>

<script>
import Vue from 'vue'
import VueSlider from 'vue-slider-component'
import datePicker from 'vue-bootstrap-datetimepicker'
import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css'
import 'vue-slider-component/theme/antd.css'
import * as VueGoogleMaps from 'vue2-google-maps'
import GmapCustomMarker from 'vue2-gmap-custom-marker'
import GmapCluster from 'vue2-google-maps/dist/components/cluster'
import { telemetry } from '@/api'

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyD8vswyC9F9G4rpJnpfpgZAwL4J0C-FhO4',
    libraries: 'places'
  }
})

Vue.component('GmapCluster', GmapCluster)

export default {
  name: 'World',
  components: {
      'gmap-custom-marker': GmapCustomMarker,
      VueSlider,
      datePicker
  },
  data () {
    return {
      center: {lat: 48, lng: 18},
      zoom: 9,
      device: 'Device',
      deviceName: 'Device',
      markers: [],
      currentMarker: 0,
      paths: [],
      pathsLoaded: [],
      InfoWindowShown: false,
      clustering: true,
      hideLowAcc: true,
      gridSize: 50,
      view: "world",
      dateFrom: this.startOfDay(this.previous2weeks(new Date())),
      dateTo: this.endOfDay(new Date()),
      options: {
        useCurrent: false,
        locale: 'sk'
      },
      sliderOptions: {
        min: 0,
        max: 1,
        interval: 1,
      },
      timestampFormater: v => (this.pathsLoaded.length>0?this.formatDate(this.pathsLoaded[this.pathsLoaded.length - v - 1].time):'')
    }
  },
  computed: {
    path() {
        return this.$router.history.current.fullPath
    }
  },
  watch: {
    $route(to, from) {
      this.updateMap()
    },
    currentMarker: function(val){
      if(this.markers.length > 0 && this.pathsLoaded.length > val) {
          var selected = this.pathsLoaded[this.pathsLoaded.length - val - 1]
          this.markers[0] = {position: {lat: selected.lat, lng: selected.lng}, event: selected.event}
          this.paths = this.pathsLoaded.slice(this.pathsLoaded.length - val - 1)
          this.$refs.mapa.$mapPromise.then((map) => {
            map.panTo(this.markers[0].position)
          })
      }
    }
  },
  mounted () {
    this.updateMap()
  },
  methods: {
    previous2weeks(date) {
      date.setDate(date.getDate() - 14)
      return date
    },
    startOfDay(date) {
      date.setHours(0,0,0,0)
      return date
    },
    endOfDay(date) {
      date.setHours(23,59,59,999)
      return date
    },
    markerClass(event, temperature) {
      if(temperature < -5) {
        return "fa fa-snowflake-o"
      }
      switch(event) {
        case "open_full":
        case "open_one_tape":
        case "open_one_button":
        case "cap_released":
        case "disarmed":
        case "heartbeat_open":
              return "fa fa-envelope-open-o"
        case "sealed":
        case "sealed_recovered":
        case "armed":
        case "heartbeat_sealed":
              return "fa fa-envelope-o"
        case "stop": return "fa fa-hourglass-o"
        case "tracing": return "fa fa-truck"
        case "start": return "fa fa-arrows"
        case "heartbeat": return "fa fa-heartbeat"
      }
      return "fa fa-gear"
    },
    openDevice(dev) {
      this.$router.push('assets/'+dev.device)
    },
    formatDate(date) {
      return (new Date(date*1000)).toLocaleString()
    },
    updateMap() {
      this.$refs.mapa.$mapPromise.then(() => {
        var fullPath = this.$router.history.current.fullPath
        if(fullPath.startsWith("/world/asset/")) {
          this.view = "asset"
            this.device = this.$router.history.current.fullPath.substring(13,this.$router.history.current.fullPath.length)
            var filter = {hideLowAccuracy: this.hideLowAcc}
            //if(this.$refs.dateFrom!==undefined) console.log(this.$refs.dateFrom.$options)
            if(this.dateFrom !== null && this.dateFrom != '') filter.dateFrom = Math.round(Date.parse(this.dateFrom)/1000)
            if(this.dateTo !== null && this.dateTo != '') filter.dateTo = Math.round(Date.parse(this.dateTo)/1000)
            telemetry.devicePositions(this.device, filter).then(response => {
              if(response.data !== undefined && response.data.length > 0) {
                this.markers = [ response.data[0] ] //response.data
                var path = []
                var bounds = new google.maps.LatLngBounds();
                for(var idx=0; idx < response.data.length; idx++) {
                  if(response.data[idx].position !== undefined && response.data[idx].position.lat !== null && response.data[idx].position.lng !== null) {
                    path.push({lat: response.data[idx].position.lat, lng: response.data[idx].position.lng, time: response.data[idx].time, event: response.data[idx].event})
                    bounds.extend({lat: response.data[idx].position.lat, lng: response.data[idx].position.lng})
                  }
                }
                this.sliderOptions.max = path.length - 1
                this.currentMarker = path.length - 1
                this.paths = path
                this.pathsLoaded = path
                this.$refs.mapa.$mapObject.fitBounds(bounds)
              }
            }).catch((error) => {
              this.$toasted.error(error)
            })
        } else {
          this.view = "world"
          telemetry.lastPositions().then(response => {
            if(response.data !== undefined) {
              this.markers = response.data
              console.log(this.markers)
              var bounds = new google.maps.LatLngBounds();
              for(var idx=0; idx < this.markers.length; idx++) {
                if(response.data[idx].position !== undefined && response.data[idx].position.lat !== null && response.data[idx].position.lng !== null) {
                    bounds.extend(this.markers[idx].position)
                }
              }
              this.$refs.mapa.$mapObject.fitBounds(bounds)
            }
          }).catch((error) => {
            this.$toasted.error(error)
          })
        }
      })
    }
  }
}
</script>
